import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteBulkProduct, hideDeleteBulkProductModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteBulkProductModal = ({
                            onDelete,
                            bulkProduct,
                            bulkProductDeleting,
                            hideDeleteBulkProductModal,
                            deleteBulkProduct,
                            visible
                          }) => {
  const bulkProductHandle = {bulkProductId: bulkProduct.bulkProductId};
  return (
    <DeleteFormModal entityType="Bulk Product" entityName={bulkProduct.name} entityHandle={bulkProductHandle} visible={visible}
                     entityDeleting={bulkProductDeleting} deleteEntity={deleteBulkProduct}
                     hideDeleteFormModal={hideDeleteBulkProductModal} onDelete={onDelete}/>);
};

DeleteBulkProductModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  bulkProduct: PropTypes.object,
  bulkProductDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteBulkProductModal: PropTypes.func.isRequired,
  deleteBulkProduct: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  visible: state.bulkProduct.deleteBulkProductModalVisible,
  bulkProduct: state.bulkProduct.bulkProductToDelete,
  bulkProductDeleting: state.bulkProduct.bulkProductDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteBulkProductModal: bindActionCreators(hideDeleteBulkProductModal, dispatch),
  deleteBulkProduct: bindActionCreators(deleteBulkProduct, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteBulkProductModal);



// WEBPACK FOOTER //
// ./src/BulkProduct/DeleteBulkProductFormModal.js